import { Outlet } from 'react-router-dom';

/**
 * Layout das paginas legais publicas (`/legal/privacy`, `/legal/terms`,
 * `/legal/account-deletion`). Wrapper minimal (so canvas) — cada tela controla
 * sua propria composicao (header band + TOC). Publico: NAO requer auth.
 */
export function LegalLayout() {
  return (
    <main className="min-h-screen bg-canvas" data-testid="legal-layout">
      <Outlet />
    </main>
  );
}
